export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { duration: 1.8 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};
